module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "EmailComponents": "static-1.44560"
    },
    "depPathPrefixes": {
      "EmailComponents": "/EmailComponents/static-1.44560"
    },
    "project": "EmailComponents",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};